module.exports = __webpack_public_path__ + "img/float-layer-heard.ea1f1338.png";